import React from 'react'
import Report from './report'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { BannerStatic } from '../../../components'

const AccelerateReport = ({ tenantId }) => {
  const [tenantAccelerateReporting] = useEvent([
    {
      eventName: 'tenantAccelerateReporting',
      shouldTimeout: false,
      onSuccess: ({ url }) => {
        window.open(url, '_blank')
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error when downloading the report.',
          isError: true
        })
      }
    }
  ])

  const handleAccelerateReportDownload = () => {
    tenantAccelerateReporting.trigger({
      tenantId
    })
  }

  return (
    <Report
      name='Skills Accelerator Report'
      description='CSV with the full Skills Accelerator data, including per-participant skills, journey progress and the aggregated breakdown.'
      buttonText='Download CSV'
      onClick={handleAccelerateReportDownload}
      isWorking={tenantAccelerateReporting.isWorking}
    />
  )
}

export default AccelerateReport
